module.exports = __webpack_public_path__ + "static/media/logo3.b2d34746.png";